import { concat } from '@ember/helper';
import { t } from 'ember-intl';
import momentFormat from 'ember-moment/helpers/moment-format';
import { and, not, or } from 'ember-truth-helpers';
import AlertIcon from 'volta/components/alert-icon';
import BvText from 'volta/components/bv-text';
import classNames from 'volta/helpers/class-names';

import type { TOC } from '@ember/component/template-only';
import type { AlertIconSignature } from 'volta/components/alert-icon';
import type { TDate } from 'volta/models/types/calendar';

export interface TasksTriggerBtnSignature {
  Args: {
    criticality?: string;
    disabled?: boolean;
    minDueDate?: TDate;
    minimized?: boolean;
    onClick?: () => void;
    showDueDate?: boolean;
    size?: AlertIconSignature['Args']['size'];
    tasksCount?: number;
  };
  Element: HTMLElement;
}

const TasksTriggerBtnComponent: TOC<TasksTriggerBtnSignature> = <template>
  <AlertIcon
    class={{classNames
      'bv-task__trigger'
      (if @minimized 'bv-task__trigger--minimized')
      (if @criticality (concat 'bv-task__trigger--' @criticality))
    }}
    @subtle={{or @minimized (not @tasksCount)}}
    @primaryIcon='checkbox-outline'
    @onClick={{@onClick}}
    @disabled={{@disabled}}
    @size={{@size}}
    @tooltip={{if
      @minDueDate
      (concat (t 'remindersPage.btnTooltip') (momentFormat @minDueDate 'L'))
    }}
    ...attributes
  >
    {{#if @tasksCount}}
      <BvText @text={{@tasksCount}} />
    {{/if}}
    {{#if (and @showDueDate @minDueDate)}}
      <BvText @text={{concat ' | ' (momentFormat @minDueDate 'L')}} />
    {{/if}}
  </AlertIcon>
</template>;

export default TasksTriggerBtnComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Tasks::TriggerBtn': typeof TasksTriggerBtnComponent;
    'tasks/trigger-btn': typeof TasksTriggerBtnComponent;
  }
}
